import React from "react";
import { message, Form } from "antd";
import styled from "styled-components";
import { DeleteOutlined } from "@ant-design/icons";

// import colors from "constants/palette";
import Button from "components/buttons/Button";
import Input from "components/inputs/Input";

export default function Features({ form, initialValue }) {
  const [inputValue, setInputValue] = React.useState(null);
  const [list, setList] = React.useState(
    initialValue?.length && typeof initialValue === "object" ? initialValue : []
  );
  console.log("feat, ", initialValue);
  const handleInput = ({ target }) => {
    setInputValue(target.value);
  };
  const handleAdd = () => {
    if (!inputValue) {
      message.error("لطفا متن ویژگی را تایپ کنید.");
      return false;
    }
    setList((e) => [...e, inputValue]);
    setInputValue(null);
    return false;
  };
  const handleEdit = ({ target }) => {
    let index = Number(target.dataset.index);
    if (!target.innerText) {
      target.innerText = list[index];
      message.error("لطفا متن ویژگی را تایپ کنید.");
      return false;
    }
    if (target.innerText !== list[index]) {
      setList((list) => {
        let temp = [...list];
        temp[index] = target.innerText;
        return temp;
      });
      message.success("با موفقیت آپدیت شد.");
    }
    return;
  };

  const handleDelete = (key) => {
    setList((e) => {
      let newList = [...e];
      newList.splice(key, 1);
      console.log(key, newList);
      return newList;
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleAdd();
    }
  };

  React.useEffect(() => {
    form.setFieldsValue({ features: list });
  }, [list]);

  return (
    <>
      <Container>
        <Form.Item name="features">
          <h3>ویژگی ها :</h3>
        </Form.Item>

        <ol>
          {list?.length
            ? list?.map((item, key) => (
                <li key={key}>
                  <span
                    data-index={key}
                    contentEditable="true"
                    className="notranslate"
                    translate="no"
                    suppressContentEditableWarning={true}
                    onBlur={handleEdit}
                  >
                    {item}
                  </span>{" "}
                  <DeleteOutlined
                    className="delete"
                    onClick={() => handleDelete(key)}
                  />
                </li>
              ))
            : null}
        </ol>
        <InputContainer>
          <Input
            value={inputValue}
            onChange={handleInput}
            onKeyDown={handleKeyDown}
          />
          <Button type="button" size="middle" onClick={handleAdd}>
            اضافه کردن{" "}
          </Button>
        </InputContainer>
      </Container>
    </>
  );
}

const Container = styled.div`
  margin-top: 3rem;
  text-align: start;

  & ol {
    list-style-position: inside;
    margin-top: 1rem;
  }

  & li {
    padding: 7px;
    border-radius: 4px;
    margin-bottom: 8px;
    border: 1px dashed #d5d5d5;
    overflow: auto;

    & .edit {
      margin-right: auto;
      float: left;
      font-size: 18px;
      cursor: pointer;
      padding: 2px 8px;
    }

    & .delete {
      color: red;
      margin-right: auto;
      float: left;
      font-size: 18px;
      cursor: pointer;
      padding: 2px 8px;
    }
  }
  & .ant-form-item {
    margin-bottom: 0px;
  }
`;
const InputContainer = styled.div`
  display: flex;
  align-items: center;
  input,
  button {
    height: 38px;
    display: flex;
    align-items: center;
  }
  & > div {
    margin-top: 0;
    margin-left: 9px;
    width: 88%;
  }
`;
